module.exports = (__webpack_require__(9))(323);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/spin/index.js from dll-reference antd_library
// module id = 348
// module chunks = 42